import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiListDataService} from './api.list-data.service';
import {TaskDistrTaskByPackageModel} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ApiTaskDistrTaskByPackageService extends ApiListDataService<TaskDistrTaskByPackageModel, TaskDistrTaskByPackageModel> {

  constructor(http: HttpClient) {
    super(http, '/Task/DistrTaskByPackage/');
  }
}
